import menu from './menu'
import commands from './commands'
import apikeys from './apikeys'
import endpoints from './endpoints'
// eslint-disable-next-line
import { installation, loadConfig } from './installation'
import store from 'store'
module.exports = {
  Installation: store.getState().configReducer,
  loadConfig: loadConfig,
  Menu: menu,
  Commands: commands,
  ApiKeys: apikeys,
  Endpints: endpoints
}
store.subscribe(() => {
  module.exports.Installation = store.getState().configReducer
})



// WEBPACK FOOTER //
// ./src/config/index.js